import { render, staticRenderFns } from "./FinishTask.vue?vue&type=template&id=1f54d030&scoped=true"
import script from "./FinishTask.vue?vue&type=script&lang=js"
export * from "./FinishTask.vue?vue&type=script&lang=js"
import style0 from "./FinishTask.vue?vue&type=style&index=0&id=1f54d030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54d030",
  null
  
)

export default component.exports